"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugTurnedOn = exports.hasConsoleLogger = exports.prefixLog = exports.logDebug = exports.logError = exports.logWarn = exports.logInfo = exports.logMessage = void 0;
var __1 = require("..");
var consoleExists = Boolean(window.console);
var consoleLogExists = Boolean(consoleExists && window.console.log);
var consoleInfoExists = Boolean(consoleExists && window.console.info);
var consoleWarnExists = Boolean(consoleExists && window.console.warn);
var consoleErrorExists = Boolean(consoleExists && window.console.error);
/**
 * Wrappers to console.(log | info | warn | error). Takes N arguments, the same as the native methods
 */
function logMessage() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugTurnedOn() && consoleLogExists) {
        // eslint-disable-next-line no-console
        console.log.apply(console, decorateLog(args, 'MESSAGE:'));
    }
}
exports.logMessage = logMessage;
function logInfo() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugTurnedOn() && consoleInfoExists) {
        // eslint-disable-next-line no-console
        console.info.apply(console, decorateLog(args, 'INFO:'));
    }
}
exports.logInfo = logInfo;
function logWarn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugTurnedOn() && consoleWarnExists) {
        // eslint-disable-next-line no-console
        console.warn.apply(console, decorateLog(args, 'WARNING:'));
    }
    // emitEvent(CONSTANTS.EVENTS.AUCTION_DEBUG, {type: 'WARNING', arguments: args});
}
exports.logWarn = logWarn;
function logError() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugTurnedOn() && consoleErrorExists) {
        // eslint-disable-next-line no-console
        console.error.apply(console, decorateLog(args, 'ERROR:'));
    }
    // emitEvent(CONSTANTS.EVENTS.AUCTION_DEBUG, {type: 'ERROR', arguments: args});
}
exports.logError = logError;
function logDebug() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (debugTurnedOn() && consoleWarnExists) {
        // eslint-disable-next-line no-console
        console.warn.apply(console, decorateLog(args, 'DEBUG:'));
    }
    // emitEvent(CONSTANTS.EVENTS.AUCTION_DEBUG, {type: 'ERROR', arguments: args});
}
exports.logDebug = logDebug;
function prefixLog(prefix) {
    function decorate(fn) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            fn.apply(void 0, __spreadArray([prefix], args, false));
        };
    }
    return {
        logError: decorate(logError),
        logWarn: decorate(logWarn),
        logMessage: decorate(logMessage),
        logInfo: decorate(logInfo),
    };
}
exports.prefixLog = prefixLog;
function decorateLog(args, prefix) {
    args = [].slice.call(args);
    // let bidder = config.getCurrentBidder() || ;
    var bidder = "";
    prefix && args.unshift(prefix);
    if (bidder) {
        args.unshift(label('#aaa'));
    }
    args.unshift(label('#3b88c3'));
    args.unshift('%cBigCrunch' + (bidder ? "%c".concat(bidder) : ''));
    return args;
    function label(color) {
        return "display: inline-block; color: #fff; background: ".concat(color, "; padding: 1px 4px; border-radius: 3px;");
    }
}
function hasConsoleLogger() {
    return consoleLogExists;
}
exports.hasConsoleLogger = hasConsoleLogger;
function debugTurnedOn() {
    var _a;
    // check url search params
    if ((_a = __1.globalSettings === null || __1.globalSettings === void 0 ? void 0 : __1.globalSettings.test) === null || _a === void 0 ? void 0 : _a.enabled) {
        return true;
    }
    return false;
}
exports.debugTurnedOn = debugTurnedOn;
